import { Component, EventEmitter, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { SupportMessageResponse } from 'src/app/model/api/api-request/support-message-response';
import { SupportMessage } from 'src/app/model/interfaces/support-message';
import { SupportService } from 'src/app/services/support.service';

@Component({
  selector: 'app-contact-support',
  templateUrl: './contact-support.component.html',
  styleUrls: ['./contact-support.component.scss']
})
export class ContactSupportComponent implements OnInit {

  public contactForm: UntypedFormGroup;
  public hideFormAndShowSuccessMessage = false;
  public isSubmitting = false;
  public showErrorMessage = false;
  public reenableConfirmButton = new EventEmitter<boolean>(false);

  private router: Router;
  private readonly formBuilder: UntypedFormBuilder;
  private supportService: SupportService;

  constructor( router: Router, formBuilder: UntypedFormBuilder, supportService: SupportService) { 
    this.router = router;
    this.formBuilder = formBuilder;
    this.supportService = supportService;
  }

  ngOnInit(): void {
    this.buildForm();
  }

  public showPage(path: string): void
  {
    this.router.navigateByUrl(path);
  }

  public buildForm(): void
  {
    const formPattern = "^[a-zæøåA-ZÆØÅ\u00C0-\u00FF]+((['. -][a-zæøåA-ZÆØÅ\u00C0-\u00FF ])?['. -][a-zæøåA-ZÆØÅ\u00C0-\u00FF]*)*$";
    const messagePattern = "^[a-zA-Z0-9'., -]{0,150}$"

    this.contactForm = this.formBuilder.group({
      fieldName: new UntypedFormControl('', { validators: [Validators.required, Validators.pattern(formPattern)]}),
      email: new UntypedFormControl('', { validators: [Validators.required, Validators.pattern('^(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$')], updateOn: 'blur' }),
      phoneNumber: new UntypedFormControl('', { validators: [Validators.required, Validators.pattern("^[0-9]*$")] }),
      identity: new UntypedFormControl('', { validators: [Validators.pattern('^[A-Za-z0-9]+$')] }),
      address: new UntypedFormControl('', { validators: [Validators.pattern(formPattern)] }),
      message: new UntypedFormControl('', { validators: [Validators.required, Validators.pattern(messagePattern)] }),
    });
  }

  get fieldName(): AbstractControl { return this.contactForm.get('fieldName'); }
  get email(): AbstractControl { return this.contactForm.get('email'); }
  get phoneNumber(): AbstractControl { return this.contactForm.get('phoneNumber'); }
  get identity(): AbstractControl { return this.contactForm.get('identity'); }
  get address(): AbstractControl { return this.contactForm.get('address'); }
  get message(): AbstractControl { return this.contactForm.get('message'); }

  public onSubmit(): void
  {
    const messageObject: SupportMessage = {
      Name: this.contactForm.controls.fieldName.value,
      Email: this.contactForm.controls.email.value,
      Phone: this.contactForm.controls.phoneNumber.value,
      Subject: '',
      Message: this.contactForm.controls.message.value,
      Fields: {
        Identity: this.contactForm.controls.identity.value,
        Address: this.contactForm.controls.address.value,
      }
    };

    this.isSubmitting = true;
    this.showErrorMessage = false;
    this.supportService.sendMessage(messageObject).subscribe((msgRes: SupportMessageResponse) => {
      this.isSubmitting = false;
      if (msgRes.Success) {
        this.hideFormAndShowSuccessMessage = true;
      } else {
        this.showErrorMessage = true;
        this.reenableConfirmButton.emit(true);
      }
    }, (error) => {
      this.isSubmitting = false;
      this.showErrorMessage = true;
      this.reenableConfirmButton.emit(true);
      console.error('Contact support message failed to send', error);
    });
  }

  public onSendNewMessageClick(): void
  {
    this.contactForm.reset();
    this.hideFormAndShowSuccessMessage = false;
  }
}
